module.exports = __webpack_public_path__ + "static/game-3-29590029dbab5359815f1807617142d4.png";